import type { AlertProps } from '@mui/material/Alert';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import * as React from 'react';
import { useEffect } from 'react';

import type { ToastMessage } from '../../models/toastMessage';
import useAppUtils from '../../utils/appUtils';
import clientUtils from '../../utils/clientUtils';

const stringify = require('json-stringify-safe');

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

interface IProps {
  toastMessage: ToastMessage;
}

const FuelSnackbar = ({ toastMessage }: IProps) => {
  const [open, setOpen] = React.useState(false);
  const { alert } = useAppUtils();

  useEffect(() => {
    if (toastMessage && toastMessage.message) setOpen(true);
  }, [toastMessage]);

  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen(false);
  };

  const copyDetailsClick = (evt) => {
    // console.log('copyDetailsClick', { toastMessage });
    clientUtils.copyToClipboard(stringify(toastMessage));
    setTimeout(() => {
      alert('Details copied.');
    }, 0);
  };

  return (
    <div>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity={toastMessage ? toastMessage.severity : 'success'} sx={{ width: '100%' }}>
          {toastMessage ? toastMessage.message : 'No message provided'}
          {toastMessage && toastMessage.details && (
            <div className="clickable underline" onClick={copyDetailsClick}>
              Click here to copy details.
            </div>
          )}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default FuelSnackbar;
